/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       CollaborationFiltersScreen.tsx
 * @author     Christian Ascone
 * @date       12/27/19 10:16 AM
 */

import React, {Component} from 'react';
import {KeyboardAvoidingView, TouchableOpacity, View,} from 'react-native';
import {i18n} from "../../../i18n/i18n";
import screenStyle from "@styles/host/collaborations/CollaborationFiltersScreenStyle";
import Loader, {LoaderState} from "@helpers/LoaderHelper";
import {dismissModal, goBack, NavigationProps} from "@helpers/NavigationHelper";
import {ConfirmButtonBottom} from "@components/ConfirmButton";
import {
    getDoorFiltersDismissCallbackFromNavigationProps,
    getFiltersHousesFromNavigationProps,
    getCollaborationFiltersFromNavigationProps
} from "@helpers/NavigationDataHelper";
import {CollaborationFilterInput, ResourceType} from "@services/src/models/index";
import {
    DoorHousesFilterBlock,
    CollaborationEmailFilterBlock,
    CollaborationStatusFilterBlock
} from "@components/FilterContainerBlock";
import {AvenirHeavyPrimaryText} from "@components/StyledText";
import {CloseColorImage} from "@components/Images/CloseColorImage";
import {Logger} from "@helpers/Logger";
import {HouseSelectionBean} from "../../../models/beans/HouseSelection";

interface State extends LoaderState {
    housesSelectionBeans: Array<HouseSelectionBean>,
    selectedType: ResourceType,
    collaboration_filters: CollaborationFilterInput,
    onDismiss: (result: CollaborationFilterInput) => void,
    applied: boolean,
}

export default class CollaborationFiltersScreen extends Component<NavigationProps, State> {
    static navigationOptions = {};

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            housesSelectionBeans: getFiltersHousesFromNavigationProps(this) || [],
            selectedType: null,
            collaboration_filters: getCollaborationFiltersFromNavigationProps(this) || {
                registryType: null,
                fromDate: null,
                toDate: null,
                registryEmail: '',
                collaborationStateOngoing: false,
                collaborationStatePending: false,
                collaborationStateConfirmed: false,
                collaborationStateCanceled: false,
            },
            onDismiss: getDoorFiltersDismissCallbackFromNavigationProps(this) || null,
            applied: false,
        };

    }

    componentWillUnmount() {
        if (this.state.applied)
            this.state.onDismiss(this.state.collaboration_filters);
    }

    updateCheckedin(checkedin: boolean) {
        let filters = this.state.collaboration_filters;
        filters.collaborationStateOngoing = checkedin;
        this.setState({collaboration_filters: filters});
    }

    updateCheckedout(checkedout: boolean) {
        let filters = this.state.collaboration_filters;
        filters.collaborationStateExpired = checkedout;
        this.setState({collaboration_filters: filters});
    }

    updatePending(pending: boolean) {
        let filters = this.state.collaboration_filters;
        filters.collaborationStatePending = pending;
        this.setState({collaboration_filters: filters});
    }

    updateConfirmed(confirmed: boolean) {
        let filters = this.state.collaboration_filters;
        filters.collaborationStateConfirmed = confirmed;
        this.setState({collaboration_filters: filters});
    }

    updateCanceled(canceled: boolean) {
        let filters = this.state.collaboration_filters;
        filters.collaborationStateCanceled = canceled;
        this.setState({collaboration_filters: filters});
    }

    updateEmail(text: string) {
        if (text != null)
            text = text.trim();
        let filters = this.state.collaboration_filters;
        filters.registryEmail = text;
        this.setState({collaboration_filters: filters});
    }

    updateSelectedHouse(key) {
        let houses = this.state.housesSelectionBeans;
        houses[key].selected = !houses[key].selected;
        let filters = this.state.collaboration_filters;
        filters.houseIds = houses.filter(bean => bean.selected).map(bean => bean.house.id);
        console.log(filters.houseIds);
        this.setState({housesSelectionBeans: houses, collaboration_filters: filters});
    }

    render() {
        return (
            <View style={screenStyle.container}>
                <Loader state={this.state}/>
                <View
                    style={[screenStyle.scrollContainer, screenStyle.scrollOuter]}>
                    <View style={{flexDirection: 'row', marginBottom: 10,}}>
                        <View style={[screenStyle.flex,]}>
                            <AvenirHeavyPrimaryText>
                                {i18n.t('screens.collaboration_filters.title')}
                            </AvenirHeavyPrimaryText>
                        </View>
                        <View style={[screenStyle.flex, {alignContent: 'flex-end', alignItems: 'flex-end',}]}>
                            <TouchableOpacity onPress={() => dismissModal(this)}>
                                <CloseColorImage style={{width: 20, height: 20,}}/>
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View
                        style={[screenStyle.getStartedContainer, screenStyle.scrollContainer]}>
                        {this.state.housesSelectionBeans != null && this.state.housesSelectionBeans.length > 0 &&
                        <View style={{flex: 1, flexDirection: 'row'}}>
                            <DoorHousesFilterBlock onPress={(key) => this.updateSelectedHouse(key)}
                                                   houseSelectionBeans={this.state.housesSelectionBeans}
                                                   style={{flex: 1, flexDirection: 'column'}}/>
                        </View>
                        }
                        {/* TODO */}
                        {/*<View style={{flex: 0.5, flexDirection: 'row'}}>*/}
                        {/*<CollaborationDateFilterBlock*/}
                        {/*value={this.state.collaboration_filters.registryEmail}*/}
                        {/*onChangeText={(text) => this.updateEmail(text)}*/}
                        {/*/>*/}
                        {/*</View>*/}
                        <View style={{flex: 1,}}>
                            <CollaborationStatusFilterBlock
                                checkedin={this.state.collaboration_filters.collaborationStateOngoing}
                                pending={this.state.collaboration_filters.collaborationStatePending}
                                confirmed={this.state.collaboration_filters.collaborationStateConfirmed}
                                canceled={this.state.collaboration_filters.collaborationStateCanceled}
                                checkedout={this.state.collaboration_filters.collaborationStateExpired}
                                onPressCheckedin={() => this.updateCheckedin(!this.state.collaboration_filters.collaborationStateOngoing)}
                                onPressPending={() => this.updatePending(!this.state.collaboration_filters.collaborationStatePending)}
                                onPressConfirmed={() => this.updateConfirmed(!this.state.collaboration_filters.collaborationStateConfirmed)}
                                onPressCanceled={() => this.updateCanceled(!this.state.collaboration_filters.collaborationStateCanceled)}
                                onPressCheckedout={() => this.updateCheckedout(!this.state.collaboration_filters.collaborationStateExpired)}
                            />
                        </View>
                        <KeyboardAvoidingView behavior={"height"} style={{flex: 0.5, flexDirection: 'row'}}>
                            <CollaborationEmailFilterBlock
                                value={this.state.collaboration_filters.registryEmail}
                                onChangeText={(text) => this.updateEmail(text)}/>
                        </KeyboardAvoidingView>
                        <View style={screenStyle.flex}>
                            {/*Dummy*/}
                        </View>
                    </View>
                    <ConfirmButtonBottom active={true} onPress={() => applyFilters(this)}
                                         title={i18n.t('buttons.collaboration_filters')}
                                         style={{marginHorizontal: 0, marginBottom: 0,}}/>
                </View>
            </View>
        );
    }
}

/**
 * Apply selected filters
 * @param {React.Component<any, State>} context
 */
function applyFilters(context: Component<NavigationProps, State>) {
    Logger.log(context.constructor.name, "Applying door filters");
    context.setState({applied: true});
    dismissModal(context);
}